import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/availableActionsForWorkOrder/${number | ':workOrderId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/availableActionsForWorkOrder/:workOrderId`;

export const URL = (workOrderId: number): RouteDefinition =>
	`${baseRoute}/availableActionsForWorkOrder/${workOrderId}`;
